export const ResourceType = {
  COMPANY_ID: 'companyId',
  PROJECT_ID: 'projectId',
  BOT_ID: 'botId',
} as const

type ResourceType = (typeof ResourceType)[keyof typeof ResourceType]

export class MissingResourceIdInRouteError extends Error {
  resourceType: ResourceType

  constructor(message: string, resourceType: ResourceType) {
    super(message)
    this.name = 'MissingResourceIdInRouteError'
    this.resourceType = resourceType
  }
}
